import React, { useContext, useEffect, useCallback, useMemo } from 'react'
import { FaExclamationTriangle, FaTimesCircle } from 'react-icons/fa'

import { DataContext } from '../DataContext'

import { issuesInNavgroup } from '../../../../utils/submissions/values'

const isNaNOrNull = value => value == null || isNaN(value)

export default () => {
    const {
        activePanel,
        changeActivePanel,
        navGroups,
        submissionState,
        navigate,
        isSubmitting,
        errorState,
        facilityID,
        uploadConfig,
        isSearchTabVisible,
        formType,
    } = useContext(DataContext)

    const isMerge = useMemo(() => formType && formType.Link === 'merge', [
        formType,
    ])
    useEffect(() => {
        if (navGroups && navGroups.length) {
            if (
                submissionState &&
                submissionState.facility &&
                submissionState.facility.UploadFacilityID &&
                isSearchTabVisible
            ) {
                changeActivePanel(navGroups[1].groupName)
            } else {
                changeActivePanel(navGroups[0].groupName)
            }
        }
    }, [navGroups])

    const navigateAndContinue = useCallback(
        group => {
            if (!isNaNOrNull(facilityID) || isMerge) {
                navigate(group)
                    .then(() => {
                        changeActivePanel(group.groupName)
                    })
                    .catch(() => {
                        // if this fails, notify for unsaved changes
                    })
            }
        },
        [navigate, facilityID]
    )

    const groupHasErrors = useCallback(
        groupName =>
            issuesInNavgroup(groupName, errorState, uploadConfig, 'Error'),
        [errorState, uploadConfig]
    )

    const groupHasWarnings = useCallback(
        groupName =>
            issuesInNavgroup(groupName, errorState, uploadConfig, 'Warning'),
        [errorState, uploadConfig]
    )

    return (
        <aside className="menu">
            <ul className="menu-list">
                {navGroups.map((group, idx) => {
                    const navigateEnabled =
                        !isSubmitting && (!isNaNOrNull(facilityID) || isMerge)
                    const isActive = group.groupName === activePanel
                    const hasWarnings = groupHasWarnings(
                        group.groupName,
                        errorState
                    )
                    const hasErrors = groupHasErrors(
                        group.groupName,
                        errorState
                    )
                    return (
                        <li key={`nav-item-${idx}`}>
                            <div
                                className={`link sideNavLink ${
                                    isActive ? 'is-active' : ''
                                } ${navigateEnabled ? '' : 'disabled-link'}`}
                                onClick={() => navigateAndContinue(group)}
                            >
                                <div className="text">{group.groupName}</div>
                                <div className="icons">
                                    {hasWarnings && (
                                        <FaExclamationTriangle
                                            className={'has-text-warning'}
                                        />
                                    )}
                                    {hasErrors && (
                                        <FaTimesCircle
                                            className={'has-text-danger'}
                                        />
                                    )}
                                </div>
                            </div>
                        </li>
                    )
                })}
            </ul>
        </aside>
    )
}
